import extranetClient from "../client";
import {
    INSURED_FAILED_CREATE_ACCOUNT,
    ADMIN_COMPANY_FAILED_CREATE_ACCOUNT,
    INSURED_SEND_A_SPECIFIC_REQUEST
} from "../../../config/constant";

/**
 * Envoie un email de notification en cas d'échec de création de compte Admin Company
 */
export const sendFailedToCreateAdminCompanyAccountEmail = async (data) => {
    try {
        const response = await extranetClient.post("contact", {
            json: {
                ...data,
                subject: ADMIN_COMPANY_FAILED_CREATE_ACCOUNT.ADMIN_COMPANY_FAILED_CREATE_SUBJECT,
                to:      ADMIN_COMPANY_FAILED_CREATE_ACCOUNT.ADMIN_COMPANY_FAILED_CREATE_TO_EMAIL,
                from:    ADMIN_COMPANY_FAILED_CREATE_ACCOUNT.ADMIN_COMPANY_FAILED_CREATE_FROM_EMAIL,
                template:ADMIN_COMPANY_FAILED_CREATE_ACCOUNT.ADMIN_COMPANY_FAILED_CREATE_TEMPLATE
            }
        }).json();
        return response;
    } catch (error) {
        if (error.name === 'HTTPError') {
            return await error.response.json();
        }
        throw error;
    }
};

/**
 * Envoie un email pour un assuré, éventuellement avec pièces jointes
 *
 * @param {Object} data  Données du mail (firstName, lastName, email, service, message, ssNum)
 * @param {File[]} files Tableau de fichiers à joindre
 */
export const sendMailInsured = async (data, files = []) => {
    // Préparation des champs communs
    const payload = {
        context: {
            firstName:    data.firstName,
            lastName:     data.lastName,
            message:      data.message,
            service:      data.service,
            ssNum:        data.ssNum,
            emailInsured: data.email,
            dossierNumber: data.dossierNumber,
            risque: data.risque
        },
        subject:  INSURED_SEND_A_SPECIFIC_REQUEST.INSURED_SEND_A_SPECIFIC_REQUEST_MAIL_SUBJECT[data.service],
        to:       INSURED_SEND_A_SPECIFIC_REQUEST.INSURED_SEND_A_SPECIFIC_REQUEST_MAIL_TO[data.service],
        from:     INSURED_SEND_A_SPECIFIC_REQUEST.INSURED_SEND_A_SPECIFIC_REQUEST_MAIL_FROM,
        template: INSURED_SEND_A_SPECIFIC_REQUEST.INSURED_SEND_A_SPECIFIC_REQUEST_TEMPLATE
    };

    try {
        if (files.length > 0) {
            // Envoi multipart/form-data
            const formData = new FormData();
            formData.append('payload', JSON.stringify(payload));
            files.forEach(file => formData.append('attachments[]', file));

            // ky détecte body=FormData et ajoute le bon Content-Type
            return await extranetClient.post("contact", { body: formData }).json();
        } else {
            // Envoi application/json
            return await extranetClient.post("contact", { json: payload }).json();
        }
    } catch (error) {
        if (error.name === "HTTPError") {
            return await error.response.json();
        }
        throw error;
    }
};

export default {
    sendFailedToCreateAdminCompanyAccountEmail,
    sendMailInsured
};
